import { adminClient as apolloClient } from '@/store/apollo';

import MemberTagsGql from '@/extensions/restrictedArea/store/graphql/queries/MemberTags.gql';
import MemberTagsSearchGql from '@/extensions/newsletter/store/graphql/queries/MemberTagsSearch.gql';

export default {
    fetchList: (cmsId = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsId) variables.cms = parseInt(cmsId);

            apolloClient
                .query({
                    query: MemberTagsGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_RSTRCT_MemberTags))
                .catch(err => reject(err));
        }),
    search: (cmsId, query) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: MemberTagsSearchGql,
                    variables: {
                        cms: parseInt(cmsId),
                        search: query
                    },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_RSTRCT_MemberTags))
                .catch(err => reject(err));
        })
};
